import { IAppState } from "./state";

export interface IAppMutations {
  OPEN_SPINNER(state: IAppState): void;
  CLOSE_SPINNER(state: IAppState): void;
}

export const AppMutations: IAppMutations = {
  OPEN_SPINNER: (state: IAppState) => {
    state.loading = true;
  },
  CLOSE_SPINNER: (state: IAppState) => {
    state.loading = false;
  },
};
